export async function getMarketGANParametersRequest() {
  let res = await fetch("/api/MarketGAN_getParameters");
  console.log(res);
  return await res.json();
}


export async function MarketGANGenerationRequest(
    sessionID: any,
    optionSelected: any
) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    ...optionSelected,
    session_id: sessionID
  });

  let res = await fetch("/api/MarketGAN_Generation", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });
  console.log('Generation: send to backend', raw);

  return await res.json();
}

export async function saveMarketGANGenerationRequest(sessionID: string) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: sessionID
  });
  let res = await fetch("/api/MarketGAN_Download", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}

export async function MarketGAN_Download(session_id: String) {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    session_id: session_id
  });

  let res = await fetch("/api/MarketGAN_Download", {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow"
  });

  return await res.json();
}